<template lang="pug">
div(v-if='checkoutStore.checkout.summary.grandTotal !== 0')
  div(class='title-lines table text-lg text-black whitespace-nowrap m-auto font-bold leading-5 my-4') Or Checkout With
  div(v-if='!route.query.checkout_token' class='mb-5')
    StripePaymentRequestButton(
      v-if='isIntegrationEnabled("stripe") && $sitewideConfig.config.stripePaymentRequestButton'
      class='mb-4'
    )
    PaypalButton(
      v-if='isIntegrationEnabled("paypal")'
      :amount='checkoutStore.checkout.summary.grandTotal'
      :button-id='buttonId'
    )

  div(v-if='isIntegrationEnabled("affirm")')
    div(class='title-lines table text-lg text-black whitespace-nowrap m-auto font-bold leading-5 my-4') Or Buy Now, Pay Later
    template(v-if='route.name == "checkout-cart"')
      AffirmButton(@click='startAffirm')
      AffirmInfo(class='mt-3')
    template(v-else)
      AffirmButton(@click='$affirm.open("/checkout/payment/")')
</template>

<script setup lang="ts">
const { $sitewideConfig, $affirm, $uiEvents } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()
const route = useRoute()
const checkoutStore = useCheckoutStore()

const buttonId = computed(() => {
  return route.name === 'checkout-cart' ? 'paypal-button-cart' : 'paypal-button-payment'
})

function startAffirm() {
  $uiEvents.$emit('checkoutStarted', 'Affirm')
  navigateTo('/checkout/affirm/')
}
</script>

<style lang="stylus" scoped>
.title-lines
    &:before,
    &:after
        border-top 1px solid $grayLight
        content ''
        display table-cell
        position relative
        top 0.5em
        width 20%
    &:before
        right 5%
    &:after
        left 5%
</style>
